import {
  acceptFunction,
  allProgramAccessTypeRequiredValidator,
  alphanumericValidator,
  atLeastOneValidatorFunction,
  B9Validator,
  checkOptionValidator,
  classificationNumberFunction,
  dateValidatorFunction,
  emailValidator,
  equalToValidator,
  emailEqualToValidator,
  futureDateValidatorFunction,
  maximumValidator,
  minimumValidator,
  moneyPositiveValidator,
  mustMatchWordFunction,
  numericValidator,
  percentageValidator,
  ProgramIdNumberOnlyValidator,
  ProgramIdValidator,
  requiredValidator,
  specificProgramAccessTypeRequiredValidator,
  thirteenDigitsValidator,
  todayOrLaterDateValidatorFunction,
  BN15Validator,
  advancedFilterDateValidatorFunction,
  mustAcceptAllFunction,
  canadianPhoneNumberValidatorFunction,
  internationalPhoneNumberValidatorFunction,
  canadianAreaCodeValidatorFunction,
  internationalAreaCodeValidatorFunction,
  usZipCodeValidatorFunction,
  postalCodeValidatorFunction,
  phoneNumberExtensionValidatorFunction,
  differentToValidator,
  hasAtLeast1AlphaCharacterFunction,
  hasAtLeast1AlphaNumericCharacterFunction,
  minValueValidator,
  maxValueValidator,
  registrationCarrierProgramIdValidator,
  registrationDutyFreeShopProgramIdValidator,
  registrationWarehouseProgramIdValidator,
  rangeLengthValidator,
  B3Validator,
  dateLessThanOrEqualFunction,
  dateGreaterThanOrEqualFunction,
  cadInvoiceDetailFormValidatorFunction,
  enrolmentPhoneNumberValidatorFunction,
  tempImportExpiryDateValidatorFunction,
  complianceCaseNoValidatorFunction,
  faxValidator,
  paymentMinAmountValidator,
  paymentMaxAmountValidator,
  paymentAmountShouldNotHaveLeadingZeros,
  cadMaxQuantityValidatorFunction,
  phoneValidatorFunction,
  strictMaxLengthValidator,
} from './carm-validation.functions';
import { ErrorCodes } from './error-code.mapper';

export const CarmValidatorsList = {
  required: {
    validateFn: requiredValidator,
    errorCode: ErrorCodes.Required,
  },
  alphanumeric: {
    validateFn: alphanumericValidator,
    errorCode: ErrorCodes.Alphanumeric,
  },
  numeric: {
    validateFn: numericValidator,
    errorCode: ErrorCodes.Numeric,
  },
  fax: {
    validateFn: faxValidator,
    errorCode: ErrorCodes.Numeric,
  },
  moneyPositive: {
    validateFn: moneyPositiveValidator,
    errorCode: ErrorCodes.MoneyPositive,
  },
  paymentAmountShouldNotHaveLeadingZeros: {
    validateFn: paymentAmountShouldNotHaveLeadingZeros,
    errorCode: ErrorCodes.InvalidPaymentAmount,
  },
  paymentMinAmount: {
    validateFn: paymentMinAmountValidator,
    errorCode: ErrorCodes.PaymentMinAmount,
  },
  paymentMaxAmount: {
    validateFn: paymentMaxAmountValidator,
    errorCode: ErrorCodes.PaymentMaxAmount,
  },
  thirteenDigits: {
    validateFn: thirteenDigitsValidator,
    errorCode: ErrorCodes.ThirteenDigits,
  },
  percentage: {
    validateFn: percentageValidator,
    errorCode: ErrorCodes.Percentage,
  },
  minLength: {
    validateFn: minimumValidator,
    errorCode: ErrorCodes.MinimumLength,
  },
  maxLength: {
    validateFn: maximumValidator,
    errorCode: ErrorCodes.MaximumLength,
  },
  strictMaxLength: {
    validateFn: strictMaxLengthValidator,
    errorCode: ErrorCodes.MaximumLength,
  },
  rangeLength: {
    validateFn: rangeLengthValidator,
    errorCode: ErrorCodes.RangeLength,
  },
  email: {
    validateFn: emailValidator,
    errorCode: ErrorCodes.InvalidEmail,
  },
  B9: {
    validateFn: B9Validator,
    errorCode: ErrorCodes.InvalidB9,
  },
  B3: {
    validateFn: B3Validator,
    errorCode: ErrorCodes.InvalidB3,
  },
  BN15: {
    validateFn: BN15Validator,
    errorCode: ErrorCodes.InvalidBN15,
  },
  businessProgram: {
    validateFn: ProgramIdValidator,
    errorCode: ErrorCodes.InvalidBusinessProgramId,
  },
  businessProgramNumberOnly: {
    validateFn: ProgramIdNumberOnlyValidator,
    errorCode: ErrorCodes.InvalidBusinessProgramId,
  },
  equalTo: {
    validateFn: equalToValidator,
    errorCode: ErrorCodes.EqualTo,
  },
  differentTo: {
    validateFn: differentToValidator,
    errorCode: ErrorCodes.DifferentTo,
  },
  emailEqualTo: {
    validateFn: emailEqualToValidator,
    errorCode: ErrorCodes.EqualTo,
  },
  minValue: {
    validateFn: minValueValidator,
    errorCode: ErrorCodes.MinValue,
  },
  maxValue: {
    validateFn: maxValueValidator,
    errorCode: ErrorCodes.MaxValue,
  },
  registrationCarrierProgramId: {
    validateFn: registrationCarrierProgramIdValidator,
    errorCode: ErrorCodes.RegistrationCarrierProgramId,
  },
  registrationWarehouseProgramId: {
    validateFn: registrationWarehouseProgramIdValidator,
    errorCode: ErrorCodes.RegistrationWarehouseProgramId,
  },
  registrationDutyFreeShopProgramId: {
    validateFn: registrationDutyFreeShopProgramIdValidator,
    errorCode: ErrorCodes.RegistrationDutyFreeShopProgramId,
  },
  allProgramAccessTypeRequired: {
    validateFn: allProgramAccessTypeRequiredValidator,
    errorCode: ErrorCodes.Required,
  },
  validOption: {
    validateFn: checkOptionValidator,
    errorCode: ErrorCodes.InvalidOption,
  },
  specificProgramAccessTypeRequired: {
    validateFn: specificProgramAccessTypeRequiredValidator,
    errorCode: ErrorCodes.Required,
  },
  dateValidator: {
    validateFn: dateValidatorFunction,
    errorCode: ErrorCodes.InvalidDate,
  },
  futureDateValidator: {
    validateFn: futureDateValidatorFunction,
    errorCode: ErrorCodes.FutureDate,
  },
  todayOrLaterDateValidator: {
    validateFn: todayOrLaterDateValidatorFunction,
    errorCode: ErrorCodes.TodayOrLaterDate,
  },
  dateLessThanOrEqualValidator: {
    validateFn: dateLessThanOrEqualFunction,
    errorCode: ErrorCodes.InvalidDate,
  },
  dateGreaterThanOrEqualValidator: {
    validateFn: dateGreaterThanOrEqualFunction,
    errorCode: ErrorCodes.InvalidDate,
  },
  atLeastOneValidator: {
    validateFn: atLeastOneValidatorFunction,
    errorCode: ErrorCodes.AtLeastOneRequired,
  },
  classNumber: {
    validateFn: classificationNumberFunction,
    errorCode: ErrorCodes.InvalidCode,
  },
  mustAccept: {
    validateFn: acceptFunction,
    errorCode: ErrorCodes.MustAccept,
  },
  mustMatchWord: {
    validateFn: mustMatchWordFunction,
    errorCode: ErrorCodes.ConfirmWordMustMatch,
  },
  advancedFilterDateValidator: {
    validateFn: advancedFilterDateValidatorFunction,
    errorCode: ErrorCodes.InvalidDate,
  },
  hasAtLeast1AlphaCharacter: {
    validateFn: hasAtLeast1AlphaCharacterFunction,
    errorCode: ErrorCodes.InvalidHas1AlphaCharacter,
  },
  hasAtLeast1AlphaNumericCharacter: {
    validateFn: hasAtLeast1AlphaNumericCharacterFunction,
    errorCode: ErrorCodes.InvalidHas1AlphaNumericCharacter,
  },
  usZipCode: {
    validateFn: usZipCodeValidatorFunction,
    errorCode: ErrorCodes.InvalidZipCode,
  },
  postalCode: {
    validateFn: postalCodeValidatorFunction,
    errorCode: ErrorCodes.InvalidPostalCode,
  },
  canadianPhoneNumber: {
    validateFn: canadianPhoneNumberValidatorFunction,
    errorCode: ErrorCodes.InvalidCanadianPhoneNumber,
  },
  internationalPhoneNumber: {
    validateFn: internationalPhoneNumberValidatorFunction,
    errorCode: ErrorCodes.InvalidInternationalPhoneNumber,
  },
  phoneNumberExtension: {
    validateFn: phoneNumberExtensionValidatorFunction,
    errorCode: ErrorCodes.InvalidExtensionNumber,
  },
  canadianAreaCode: {
    validateFn: canadianAreaCodeValidatorFunction,
    errorCode: ErrorCodes.InvalidCanadianAreaCode,
  },
  internationalAreaCode: {
    validateFn: internationalAreaCodeValidatorFunction,
    errorCode: ErrorCodes.InvalidInternationalAreaCode,
  },
  tempImportExpiryDateValidator: {
    validateFn: tempImportExpiryDateValidatorFunction,
    errorCode: ErrorCodes.ExpiryDate,
  },
  mustAcceptAll: {
    validateFn: mustAcceptAllFunction,
    errorCode: ErrorCodes.MustAccept,
  },
  cadInvoiceDetailValidator: {
    validateFn: cadInvoiceDetailFormValidatorFunction,
    errorCode: ErrorCodes.MustAccept,
  },
  enrolmentPhoneNumber: {
    validateFn: enrolmentPhoneNumberValidatorFunction,
    errorCode: ErrorCodes.InvalidEnrolmentPhone,
  },
  complianceeCaseNo: {
    validateFn: complianceCaseNoValidatorFunction,
    errorCode: ErrorCodes.InvalidComplianceCaseNo,
  },
  cadMaxQuantity: {
    validateFn: cadMaxQuantityValidatorFunction,
    errorCode: ErrorCodes.CadMaxQuantity,
  },
  phone: {
    validateFn: phoneValidatorFunction,
    errorCode: ErrorCodes.InvalidPhoneCode,
  }
};
